import Config from '../components/common/Config';
import { axiosPostEncryptedForm, joinApiUrl, postEncryptedForm } from './eposApi';

function resolveBearerToken(bearerToken) {
  return bearerToken || localStorage.getItem('token') || localStorage.getItem('accessToken');
}

function orderHistoryDetailsUrl() {
  return joinApiUrl(Config.API_URL, 'ws-order-history-details');
}

export async function fetchOrderHistoryDetails(orderId, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  const { response, data } = await postEncryptedForm(
    orderHistoryDetailsUrl(),
    token,
    { orderId: String(orderId ?? '') }
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return data;
}

export async function axiosFetchOrderHistoryDetails(orderId, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  return axiosPostEncryptedForm(orderHistoryDetailsUrl(), token, {
    orderId: String(orderId ?? ''),
  });
}
